// import Head from 'next/head'
import React from "react";
import ReactDOM from "react-dom";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import withReactRouter from "./utils/withReactRouter";
import { ConfirmProvider } from "material-ui-confirm";

// import '../webpack/css/lib.js';
//import "./webpack/js/app.js";
import "./oldUi/lib/ext-js-4.2.2/resources/ext-theme-classic/ext-theme-classic-all.css";
import "./oldUi/lib/mzExt-3.6.0/mzPivotGrid.css";
import "./oldUi/lib/webix/core/codebase/webix.min.css";
//cdn.materialdesignicons.com/3.0.39/css/materialdesignicons.min.css
// import 'https//cdn.materialdesignicons.com/3.0.39/css/materialdesignicons.min.css';
import "./oldUi/lib/webix/hint/hint.css";
import "./oldUi/lib/webix/enjoyhint/enjoyhint.css";
import "./css/lib/fontawesome/css/all.css";
import "./oldUi/lib/slick/slick.css";
import "./oldUi/lib/slick/slick-theme.css";
import "./oldUi/lib/dhtmlx-codebase/dhtmlxscheduler_material.css";
import "./css/materialdesignicons.min.css";

import "./oldUi/lib/ckeditor/skins/moono-lisa/editor.css";
import "./oldUi/lib/ckeditor/plugins/wsc/skins/moono-lisa/wsc.css";
import "./oldUi/lib/ckeditor/plugins/scayt/skins/moono-lisa/scayt.css";
import "./oldUi/lib/ckeditor/plugins/scayt/dialogs/dialog.css";
import "./oldUi/lib/ckeditor/plugins/tableselection/styles/tableselection.css";
import "./oldUi/lib/ckeditor/contents.css";
import "./oldUi/lib/webix/kanban/codebase/kanban.css";
import "./oldUi/lib/webix/pivot/codebase/pivot.css";
import "./oldUi/lib/codemirror-5.37.0/lib/codemirror.css";
import "./oldUi/lib/codemirror-5.37.0/addon/hint/show-hint.css";
import "./oldUi/lib/codemirror-5.37.0/addon/lint/lint.css";

// ag grid start move to scss base
import "./index.css";
import "./scss/application/views/table/agGrid.scss";
import "./scss/application/views/table/pageHeadersAndToolbars/Header.scss";
import "./scss/application/views/table/pageHeadersAndToolbars/Header2.scss";
import "./scss/application/views/table/pageHeadersAndToolbars/Toolbar.scss";
import "./scss/application/views/table/pageHeadersAndToolbars/newEditor.css";
import "./scss/application/views/table/colHeaders/ColHeader.scss";
import "./scss/application/views/table/colHeaders/AddColumn.scss";
import "./scss/application/views/table/groupedAggregateCells/GroupedCellRenderer.scss";
import "./scss/application/views/table/groupedAggregateCells/FullWidthGroupedCellRenderer.scss";
import "./scss/application/views/table/columnEditors/MultiSelect.scss";
import "./scss/application/views/table/columnEditors/DropDown.scss";
import "./scss/application/views/table/columnEditors/Lookup.scss";
import "./scss/application/views/table/columnEditors/Text.scss";
import "./scss/application/views/table/columnEditors/MultiLine.scss";
import "./scss/application/views/table/columnEditors/DateTime.scss";
import "./scss/application/views/table/columnEditors/Boolean.css";
import "./scss/application/views/table/columnEditors/CheckboxGroup.scss";
import "./scss/application/views/table/columnEditors/File.scss";
import "./scss/application/views/table/columnEditors/Formula.scss";
import "./scss/application/views/table/columnEditors/Triggers.scss";
import "./scss/application/views/table/columnEditors/Subsheet.scss";
import "./scss/application/views/table/CustomPinnedRow.scss";
import "./scss/application/views/table/Pagination.scss";
import "./scss/application/views/table/columnEditors/FullWidthCell.scss";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "./scss/application/CustomTooltip.scss";
import "./scss/application/settings/settings-windows.scss";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
// import "ag-grid-enterprise";
// ag grid end

// import '../webpack/css/app.js';
import "./scss/application-theme-dark.scss";
import "./scss/application-theme-light.scss";

import "./css/user/codemirror/codemirror.css";
import "./css/user/ckeditor.css";
import Util from "./utils/Utils";
import { Provider } from "mobx-react";
import { useStore } from "./app/AppStore";
import App from "./app/App";
import * as serviceWorker from "./serviceWorker";
import COLORS from "scss/colors.module.scss";
import {
  createMuiTheme,
  ThemeProvider as MuiThemeProvider,
} from "@material-ui/core";
// import { StylesProvider } from "@material-ui/core/styles";

import { ThemeProvider } from "styled-components";

if (!global.window) {
  global.window = {};
}
window.baseUrl = ""; //api
window.serverUrl = `${window.location.protocol}://${window.location.host}`;
window.mainDomain = "api";
window.isLoggedInForFirstTimeSession = false;
window.isLoggedInForFirstTime = false;
window.currentTheme = "light_theme";
window.helpLinksData = [];
window.loggedInUserColumns = [];
window.Util = Util;
window.PACK = {};

const theme = createMuiTheme({
  palette: {
    primary: { 500: COLORS.THEME_COLOR, main: COLORS.THEME_COLOR, light: COLORS.THEME_COLOR_BRIGHT },
  },
});

function MyApp({ pageProps = {} }) {
  const store = useStore(pageProps.initialState);

  return (
    <MuiThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
            <ConfirmProvider
              defaultOptions={{
                dialogProps: {
                  maxWidth: "xs",
                  PaperProps: {
                    style: {
                      borderRadius: 0,
                    },
                    classes: {
                      root: "confirmation-dialog",
                    },
                  },
                },
                cancellationButtonProps: {
                  color: "primary",
                },
              }}
            >
              <DndProvider backend={HTML5Backend}>
                <App {...pageProps} />
                {store.dialogsToDom}
              </DndProvider>
            </ConfirmProvider>
        </Provider>
      </ThemeProvider>
    </MuiThemeProvider>
  );
}

const AppWithReactRouter = withReactRouter(MyApp);
ReactDOM.render(<AppWithReactRouter />, document.getElementById("root"));
serviceWorker.unregister();
